var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.6819,
    y: 19.0908,
    width: 7.27273,
    height: 17.7273,
    fill: "#EEFFFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.04541,
    width: 7.27273,
    height: 36.8182,
    fill: "#EEFFFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72171 18.4918L1.36361 18.7646V19.2149V25.4545V27.2902L2.8237 26.1776L14.9639 16.9268L27.1783 26.1792L28.6363 27.2836V25.4545V19.2149V18.763L28.2762 18.4902L15.5112 8.82075L14.9606 8.40371L14.4113 8.82232L1.72171 18.4918Z",
    fill: "#1FC086",
    stroke: "#004945",
    strokeWidth: 1.81818
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHLogo);
export default __webpack_public_path__ + "static/media/h-logo.1cf8e47338108071e058b555013c24f0.svg";
export { ForwardRef as ReactComponent };